/**
 * 从 URL 中解析出比赛 ID
 *
 * @param {string} url - 需要解析的 URL
 * @returns {number | null} - 如果成功解析出比赛 ID,则返回该数值,否则返回 null
 */
function getMatchIdFromUrl(url) {
    try {
        const urlParts = url.split('/')
        const lastPartIndex = urlParts.length - 1
        const matchId = Number(urlParts[lastPartIndex])

        if (isNaN(matchId)) {
            return null
        }

        return matchId
    } catch (error) {
        console.error('Error parsing match ID from URL:', error)
        return null
    }
}

/**
 * 根据给定的 ID 进行格式化处理。
 * 如果 ID 大于或等于 50,000,000,则从 ID 中减去 50,000,000 并返回结果字符串。
 * 否则,直接返回原始的 ID 字符串。
 */
export function convertToFiveMillion(id) {
    if (!id) return id
    // 将参数转换为数字类型
    const number = Number(id)

    // 判断参数是否大于等于 5e7 (50000000)
    if (number >= 5e7) {
        return number - 5e7
    } else {
        return number
    }
}

/**
 * @description 睡眠
 * @param {*} ms
 * @returns
 */
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}


/**
 * 节流
 * @param {function} fn
 * @param {string} delay
 */
export function _throttle(fn, delay = 100) {
    let timer = null
    return function () {
      const self = this
      const args = Array.from(arguments) // 将 arguments 转为数组
      if (timer) return
      timer = setTimeout(function () {
        fn.apply(self, args)
        timer = null
        clearTimeout(timer)
      }, delay)
    }
  }



// WEBPACK FOOTER //
// ./src/util/common.js